export default {
	verify: {
		title: "Verificação em duas etapas",
		totpHint: "Digite o código de 6 dígitos do seu aplicativo autenticador.",
		emailHint: "Enviamos um código de 6 dígitos para o seu e-mail.",
		backupHint: "Digite um dos seus códigos de backup.",
		codeLabel: "Código de verificação",
		backupLabel: "Código de backup",
		rememberDevice: "Lembrar este dispositivo por 30 dias",
		submit: "Verificar",
		invalidCode: "Código inválido ou expirado. Tente novamente.",
		resend: "Reenviar código",
		resending: "Reenviando...",
		resent: "Código reenviado para o seu e-mail",
		resendError: "Não foi possível reenviar o código",
		useBackup: "Usar código de backup",
		useCodeInstead: "Usar código do aplicativo",
		back: "Voltar ao login",
	},
	settings: {
		title: "Autenticação em duas etapas",
		description:
			"Adicione uma camada extra de segurança à sua conta exigindo um código além da senha ao entrar.",
		enabled: "Autenticação em duas etapas ativada",
		disabled: "Autenticação em duas etapas desativada",
		disabledHint: "Sua conta está protegida apenas pela senha.",
		methodLabel: "Método",
		backupRemaining: "{count} código(s) de backup restante(s)",
		activate: "Ativar",
		regenerate: "Regenerar códigos de backup",
		disable: "Desativar",
	},
	methods: {
		totp: "Aplicativo autenticador",
		totpDesc: "Use Google Authenticator, Authy ou similar (recomendado).",
		email: "Código por e-mail",
		emailDesc: "Receba um código por e-mail a cada login.",
	},
	activate: {
		title: "Ativar autenticação em duas etapas",
		chooseMethod: "Escolha como deseja receber os códigos de verificação.",
		continueBtn: "Continuar",
		totpScan:
			"Escaneie o QR Code com seu aplicativo autenticador e informe o código gerado.",
		totpManual: "Ou insira esta chave manualmente:",
		qrAlt: "QR Code para configuração do autenticador",
		emailSent: "Enviamos um código de verificação para o seu e-mail.",
		confirm: "Ativar",
	},
	backup: {
		title: "Códigos de backup",
		warning:
			"Guarde estes códigos em um local seguro. Cada código pode ser usado uma única vez para entrar caso você perca o acesso ao seu método principal. Eles não serão exibidos novamente.",
		copy: "Copiar",
		download: "Baixar",
		saved: "Já salvei meus códigos",
		fileHeader: "Códigos de backup da autenticação em duas etapas — ORI",
	},
	disable: {
		title: "Desativar autenticação em duas etapas",
		description:
			"Para confirmar, digite um código do seu método de verificação ou um código de backup.",
		codeLabel: "Código de verificação ou backup",
	},
	regenerate: {
		title: "Regenerar códigos de backup",
		warning:
			"Ao gerar novos códigos, os códigos de backup anteriores deixarão de funcionar.",
		confirm: "Gerar novos códigos",
	},
	devices: {
		title: "Dispositivos confiáveis",
		empty: "Nenhum dispositivo confiável",
		emptyHint:
			"Dispositivos lembrados durante o login aparecem aqui e não pedem o código por 30 dias.",
		unknownDevice: "Dispositivo desconhecido",
		lastUsed: "Último uso",
		never: "Nunca",
		expires: "Expira em",
		revoked: "Dispositivo revogado",
		revokeError: "Não foi possível revogar o dispositivo",
	},
	reminder: {
		title: "Proteja sua conta",
		text: "Ative a verificação em duas etapas para uma camada extra de segurança ao entrar.",
		activate: "Ativar agora",
		dismiss: "Dispensar",
	},
	messages: {
		statusError: "Não foi possível carregar o status da autenticação em duas etapas",
		setupError: "Não foi possível iniciar a configuração",
		activated: "Autenticação em duas etapas ativada com sucesso",
		invalidCode: "Código inválido. Verifique e tente novamente.",
		copied: "Copiado para a área de transferência",
		copyError: "Não foi possível copiar",
		disabled: "Autenticação em duas etapas desativada",
		regenerated: "Novos códigos de backup gerados",
		regenerateError: "Não foi possível regenerar os códigos de backup",
	},
};
